import React, { useState } from "react";
import styles from "./style.module.css";
import * as PropTypes from "prop-types";
import { ReactComponent as CurrentIcon } from './ic_selected.svg';

const ReasonItem = React.memo(({ reasonName, reasonType, selectReason, currentReason }) => {

  return (
    <>
      <div
        key={reasonName}
        className={styles.reasonItem}
        onClick={() => selectReason(reasonType)}
      >
        <div className={styles.reasonName} >
          {reasonName}
        </div>
        <div className={styles.reasonCurrentIcon}>
          { currentReason &&
          <CurrentIcon />}
        </div>
      </div>
    </>
  );
});

ReasonItem.propTypes = {
  reasonName: PropTypes.string.isRequired,
  selectReason: PropTypes.func.isRequired,
  currentReason: PropTypes.bool.isRequired,
};

export default ReasonItem;
